(function(){
  function start(){
    var wrap = document.querySelector('.pw');
    if(!wrap) return;
    var els = wrap.querySelectorAll('.rev');
    if(!els.length) return;

    function counts(scope){
      var n = scope.querySelector('[data-count]');
      if(!n || n.dataset.done) return;
      n.dataset.done = '1';
      var end = parseInt(n.getAttribute('data-count'),10) || 0, t0 = null, dur = 1200;
      function step(ts){
        if(!t0) t0 = ts;
        var p = Math.min((ts-t0)/dur,1);
        n.textContent = Math.round(end*(1-Math.pow(1-p,3)));
        if(p<1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    if(!('IntersectionObserver' in window)){
      els.forEach(function(el){ el.classList.add('in'); counts(el); });
      return;
    }

    document.documentElement.classList.add('pde-anim');

    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(!e.isIntersecting) return;
        e.target.classList.add('in');
        counts(e.target);
        io.unobserve(e.target);
      });
    }, {threshold:0.12, rootMargin:'0px 0px -40px 0px'});

    Array.prototype.forEach.call(els, function(el,i){
      el.style.transitionDelay = (i%4)*80 + 'ms';
      io.observe(el);
    });

    setTimeout(function(){
      Array.prototype.forEach.call(els, function(el){
        var r = el.getBoundingClientRect();
        if(r.top < window.innerHeight && r.bottom > 0){ el.classList.add('in'); counts(el); }
      });
    }, 60);
  }

  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', start); }
  else { start(); }
})();
